import { useId } from 'react';

interface SliderProps {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  label?: string;
  disabled?: boolean;
}

export function Slider({
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  label,
  disabled,
}: SliderProps) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1">
      {label ? (
        <label htmlFor={id} className="text-sm text-[var(--ac-text-muted)] flex justify-between">
          <span>{label}</span>
          <span>{value}</span>
        </label>
      ) : null}
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled ?? false}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full accent-[var(--ac-accent)]"
        style={{ accentColor: 'var(--ac-accent)' }}
      />
    </div>
  );
}
